
export const airstruction = {
  airTitle: '<p style=\'font-size:18px;color:#333333;margin-top:20px\'>长虹空调三包政策</p>',
  airContent: `
    <p class="title" id="airinstruction">安装说明</p>
    <p>凡购买长虹家用壁挂式、落地式空调的用户，凭随机所附的“长虹空调签约服务商上门安装服务质量反馈卡”和“有效购机凭证（长虹自营电商平台可能为电子发票）”，享受长虹空调指定服务网点一次性免费上门安装服务；窗机不免费安装，按购机卖场规定向用户收取安装费、材料费。</p>
    <P>下列情况，可协商额外收费服务</P>
    <p>1. 无任何形式的长虹空调安装卡并且不能出示有效购机凭证(同时满足两个条件)</p>
    <p>2. 需加长内外机连接管、线；</p>
    <p>3.特殊条件下的打孔；</p>
    <p>4. 需室外高空作业且购机商场有明确的高空作业定义和收费标准的，可按商场规定执行(线上电商平台收费标准可参照电商公示收费标准执行)；</p>
    <p>5. 用户原因空调搬迁移位和重新安装；</p>
    <p>6. 空调的额定运转电流大于或等于16A时，应参照国家标准对空调的供电单独配装断路保护器或空气开关，断路保护器或空气开关由安装单位有偿提供时；对改动线路、接线、接电源插座、空气开关等涉电工作为保证用户用电安全，由用户找有资质证的专业电工完成，专业电工需要付费时，由用户承担；</p>
    <p>7. 因用户安装位置条件所限（如需长距离横跨、转角等），无其他合适安装位置，必须采取吊机安装的，可协商收费，卖场有此类似规定时按卖场规定执行；</p>
    <p>8. 安装过程中如遇玻璃的由用户自行解决或改变穿孔位置，如用户坚持的可向用户协商收费开孔，但必须保证开孔质量和安全；卖场关于此条有专门规定的，按用户购机的卖场规定执行；</p>
    <p>9. 用户安装位置无法施工，需动用专用辅助设备（吊笼、脚手架、工程设备等），可由服务商提出解决方案（费用以实际发生为准），由用户决定自行处理或委托服务商处理，待安装施工条件具备后正常施工；</p>
    <p>10. 因用户安装的防盗网导致外机无法安装，可由服务商提出解决方案（费用以实际发生为准），由用户决定自行处理或委托服务商处理，待安装施工条件具备后正常施工；</p>
    <p>11. 大型柜机所需特殊支架等安装材料；</p>
    <p>12. 不属于随机所配的标准部件，如接水盘、机罩、机垫、清洗剂等，用户需要时；</p>
    <p>13. 当地卖场规定安装支架可收费时；</p>
    <p>14. 用户安装地点距安装服务商所在地较远，超出卖场规定的免费范围时，可协商收取一定的远程费用（以卖场规定为准，卖场无收费规定时不允许收取）。</p>
    <p class="title" id="airdeadline">三包期限</p>
    <p>1. 窗机不论何时购买，一律按国家“新三包”政策执行。即整机包修一年，主要部件包修三年。</p>
    <p>2. 家用分体空调标准的包换和包退期限按照国家“新三包”规定实行，特殊活动期间延长包换期的政策以活动说明和相关附加凭证为准。大连锁、电商平台购机以对应卖场的政策为准。</p>
    <p>3. 家用分体空调用户以购机日期为准享受不同包修期限：</p>
    <p class="sm-tit">（1）2009年1月1日前购机，按购机时包修政策执行（最长整机包修三年，主要部件包修五年，该时间段内的机器均已过保）。</p>
    <p class="sm-tit">（2）2009年1月1日起，长虹“三高效”系列空调整机包修六年，遥控器包修一年。非“三高效”系列空调整机包修三年，主要部件包修五年，遥控器包修一年。主要部件包括压缩机、风扇电机、温控器和电控板。</p>
    <p class="sm-tit">（3）2010年9月1日起，长虹分体家用空调整机标准包修期为六年，遥控器包修一年。</p>
    <p class="sm-tit"> （4）在各类促销活动期间，购买长虹空调并获赠长虹空调VIP服务金卡的用户，其信息录入长虹空调服务系统，凭VIP服务金卡和对应的有效购机凭证可按VIP服务金卡上所明示的内容享受更长的包修期或其他服务优惠政策（截至目前，主要为整机包修十年卡，少数为整机包修十二年卡，一年到两年包换的内容在2015年已取消，不会有此类包换机产生）。</p>
    <p class="sm-tit">（5）2016年3月1日起，购买长虹空调并获赠长虹官方延保卡的用户（如十年包修卡），凭延保卡和对应的有效购机凭证可按延保卡上所明示的内容享受在六年标准整机包修期基础上延长四年包修（总计包修十年）的政策。</p>
    <p class="sm-tit">4. 三包有效期自发票（或确认有效的购机凭证）开具之日起计算。</p>
    <p class="sm-tit">5. 所有换机用户需由四川快益点电器服务连锁有限公司或长虹空调公司指定的专业服务商按照约定换机流程上门鉴定，并出具换机鉴定证明。</p>
    <p class="title" id="airrange">不属于“三包”范围的情况说明</p>
    <p>1、因用户使用、维护或保管不当造成损坏的；</p>
    <p>2、因不可抗拒外部因素如：火灾、水灾、地震等造成损坏的；</p>
    <p>3、非长虹空调特约安装维修网点拆动造成损坏的；</p>
    <p>4、包修凭证与产品型号不符、涂改或伪造的；</p>
    <p>5、工厂或经销商已明示为折价处理的“等外品”或“处理品”；</p>
    <p>6、超过包修期或非长虹空调承诺免费的服务项目和内容；</p>
    <p>7、需要退换机，但性能指标或技术参数达到产品设计及说明标准的；</p>
    <p>8、需要退换机，但没有经过四川快益点电器服务连锁有限公司或长虹空调公司指定的专业服务商鉴定，不能提供有效鉴定证明的；</p>
    <p>9、需要超出标准包修期享受三包，但不能同时提供长虹空调官方发放的相应的VIP服务金卡及对应的有效购机凭证的；</p>
    <p>10、其他不符合新三包规定的免费处理的情况。</p>
    <p>11、上述不属于三包范围的情况，需由长虹空调特约安装维修服务商处理时，可提供收费服务。</p>
    <p>12、关于“有效购机凭证”：以用户购机时销售商开具的销售发票为主；</p>
    <p>12.1 其他加盖销售单位公章或财务专用章且登记基本购机信息的收款收据、发货单证、保修证明等，亦可认定为有效购机凭证;</p>
    <p>12.2 电商平台购机(如京东/淘宝/天猫、长虹自营电商如各类POP店、长虹商城)出具的电子发票视同有效购机凭证;</p>
    <p>12.3 对于销售客户出具的非常明显的”假发票、假收据、假VIP卡、假十年卡”等，由快益点公司报空调公司(用户服务部)协调当地空调产品管理中心处理。</p>
  `

  // <p class="title" id="airstandard">空调服务收费标准</p>
  //   <p>
  //     <img src="./static/air_cost_standrad1.png" width="100%">
  //   </p>
  //   <p>备注：</p>
  //   <P>1、上述费用仅为维修费用，不包含检测费用和备件费用；维修服务收费=上门检测费（30元）+维修费（见上表）+备件材料费，（但补漏、加氟此项维修费含备件材料费）。</p>
  //   <P>2、上门检测费：若上门检测出故障后因用户原因不同意维修，仅收上门检测费30元；若因无备件、技术等服务承揽商自身原因而无法修复，则不收取任何费用。</p>
  //   <P>3、变频空调上述维修费用标准上浮20％。</p>
  //   <P>4、此收费标准为非保修期收费维修的上限，任何服务承揽商收费不得高于此标准。</p>
  //   <P>5、同时维修多个故障，维修费不累加，以故障维修费用标准最高的结算。</p>
  //   <P>6、移机费不包括移机地点之间的运输费，可向用户协商收取。</p>
  //   <P>7、用户在20公里内不收路费，超过20公里，1元/每公里，超过50公里，用户和服务承揽商协商收费。</p>
  //   <P>8、室内机调整包括调整室内机噪音、漏水及其它结构性项目调整。</p>
  //   <P>9、室外机调整包括噪音、漏水、压缩机抱轴、四通阀卡死、松动等。</p>
  //   <P>10、上门咨询、保养包括换旋钮、遥控器、导风条、过滤网、空气清新装置、光触媒、出水嘴等。</p>
  //   <p class="title" id="airinstall">空调安装收费标准</p>
  //   <p><img src="./static/air_cost_standrad2.png" width="100%"></p>
  //   <p>备注：</p>
  //   <p>1、环保冷媒，安装人员必须使用真空泵抽真空。</p>
  //   <P>2、以上收费材料照片因地区差异，可能会与实物有差异，请以实物为准。</p>
  //   <P>3、对改动线路、接线、电源插座等涉及电路工作的，为保证用户用电安全，请用户找专业电工完成，产生费用由用户承担。</p>
  //   <P>4、以上收费标准为收费指导价，服务单位提供收费服务时必须与用户友好协商，收费不得超过此指导价，并按用户要求开具收费凭证。如当地有已出台行业收费标准的按当地收费标准执行。</p>
  //   <P>5、拆机移机费、维修费、配件费和以上未涉及的其它费用，请参照上门服务人员出示的厂家统一收费标准，如服务人员未出示收费标准，用户可以拒绝付费，并致电厂家服务热线投诉。用户自备材料的，后期导致产品质量问题或安全问题，不在厂家三包范围，由用户自行负责。</p>

}



// WEBPACK FOOTER //
// ./src/struction/airStruction.js